/* ── U Against U Theme JS ─────────────────────────────────── */

/* Escape special HTML characters to prevent injection via API data */
function escHtml(str) {
  return String(str == null ? '' : str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

/* Mobile Nav */
function uauToggleMobileNav() {
  const nav = document.getElementById('mobile-nav');
  if (!nav) return;
  nav.classList.toggle('open');
  document.body.style.overflow = nav.classList.contains('open') ? 'hidden' : '';
}

/* Cart Drawer (Shopify Ajax API) */
function uauOpenCart() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      uauRenderCart(cart);
      document.getElementById('cart-drawer-overlay').classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
}

function uauCloseCart() {
  const overlay = document.getElementById('cart-drawer-overlay');
  if (overlay) overlay.classList.remove('is-open');
  document.body.style.overflow = '';
}

function uauRenderCart(cart) {
  const bodyEl    = document.getElementById('cart-drawer-body');
  const footerEl  = document.getElementById('cart-drawer-footer');
  const countEls  = document.querySelectorAll('.cart-count');
  const count     = cart.item_count;

  countEls.forEach(el => {
    el.textContent = count;
    el.style.display = count > 0 ? 'flex' : 'none';
  });

  if (count === 0) {
    bodyEl.innerHTML = `<div class="cart-empty-msg"><svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg><p>Your bag is empty.<br>Start shopping to add items.</p></div>`;
    if (footerEl) footerEl.style.display = 'none';
    return;
  }

  const price = n => (n / 100).toFixed(2);
  bodyEl.innerHTML = '';
  cart.items.forEach(item => {
    const row = document.createElement('div');
    row.className = 'cart-item-row';

    const img = document.createElement('img');
    img.className = 'cart-item-img';
    img.src = item.image;
    img.alt = item.product_title;

    const info = document.createElement('div');
    info.className = 'cart-item-info';

    const name = document.createElement('p');
    name.className = 'cart-item-name';
    name.textContent = item.product_title;

    const variant = document.createElement('p');
    variant.className = 'cart-item-variant';
    variant.textContent = item.variant_title || '';

    const itemPrice = document.createElement('p');
    itemPrice.className = 'cart-item-price';
    itemPrice.textContent = '$' + price(item.price);

    const qtyRow = document.createElement('div');
    qtyRow.className = 'cart-item-qty-row';

    const decBtn = document.createElement('button');
    decBtn.className = 'qty-btn';
    decBtn.dataset.key = item.key;
    decBtn.dataset.action = 'dec';
    decBtn.textContent = '−';

    const qtySpan = document.createElement('span');
    qtySpan.style.cssText = 'font-size:.82rem;font-weight:600;min-width:20px;text-align:center';
    qtySpan.textContent = String(Number(item.quantity));

    const incBtn = document.createElement('button');
    incBtn.className = 'qty-btn';
    incBtn.dataset.key = item.key;
    incBtn.dataset.action = 'inc';
    incBtn.textContent = '+';

    qtyRow.appendChild(decBtn);
    qtyRow.appendChild(qtySpan);
    qtyRow.appendChild(incBtn);

    info.appendChild(name);
    info.appendChild(variant);
    info.appendChild(itemPrice);
    info.appendChild(qtyRow);

    row.appendChild(img);
    row.appendChild(info);
    bodyEl.appendChild(row);
  });

  if (footerEl) {
    footerEl.style.display = 'block';
    const totalEl = document.getElementById('cart-total-price');
    if (totalEl) totalEl.textContent = '$' + price(cart.total_price);
  }

  // Qty buttons
  bodyEl.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const key    = btn.dataset.key;
      const action = btn.dataset.action;
      const item   = cart.items.find(i => i.key === key);
      if (!item) return;
      const qty = action === 'inc' ? item.quantity + 1 : item.quantity - 1;
      uauUpdateCartItem(key, qty);
    });
  });
}

function uauUpdateCartItem(key, qty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty }),
  })
    .then(r => r.json())
    .then(cart => uauRenderCart(cart));
}

function uauAddToCart(variantId, qty) {
  qty = qty || 1;
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: qty }),
  })
    .then(r => r.json())
    .then(() => {
      uauOpenCart();
      uauShowToast('Added to bag!');
    });
}

/* Product Page – variant / image selection */
function uauInitProductPage() {
  /* Size buttons */
  document.querySelectorAll('.size-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.size-btn').forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      const variantId = btn.dataset.variantId;
      const addBtn = document.getElementById('add-to-cart-btn');
      if (addBtn && variantId) addBtn.dataset.variantId = variantId;
    });
  });

  /* Color swatches (media swap) */
  document.querySelectorAll('.color-swatch[data-media-index]').forEach(sw => {
    sw.addEventListener('click', () => {
      document.querySelectorAll('.color-swatch').forEach(s => s.classList.remove('is-active'));
      sw.classList.add('is-active');
      const mediaIndex = parseInt(sw.dataset.mediaIndex, 10);
      const mainImg = document.getElementById('main-product-img');
      const allMedia = window.__uauMedia || [];
      if (mainImg && allMedia[mediaIndex]) {
        mainImg.src = allMedia[mediaIndex];
      }
      const colorLabel = document.getElementById('selected-color-label');
      if (colorLabel) colorLabel.textContent = sw.dataset.colorName || '';
      // Sync thumbnails
      uauSelectThumb(mediaIndex);
    });
  });

  /* Thumbnails */
  document.querySelectorAll('.thumb-btn[data-media-index]').forEach(btn => {
    btn.addEventListener('click', () => {
      uauSelectThumb(parseInt(btn.dataset.mediaIndex, 10));
    });
  });

  /* Add to cart button */
  const addBtn = document.getElementById('add-to-cart-btn');
  if (addBtn) {
    addBtn.addEventListener('click', () => {
      const variantId = addBtn.dataset.variantId;
      if (!variantId) { uauShowToast('Please select a size'); return; }
      uauAddToCart(variantId, 1);
    });
  }
}

function uauSelectThumb(idx) {
  const allMedia = window.__uauMedia || [];
  const mainImg = document.getElementById('main-product-img');
  if (mainImg && allMedia[idx]) mainImg.src = allMedia[idx];
  document.querySelectorAll('.thumb-btn').forEach(b => {
    b.classList.toggle('is-active', parseInt(b.dataset.mediaIndex, 10) === idx);
  });
}

/* Toast */
let _toastTimer;
function uauShowToast(msg) {
  let t = document.getElementById('uau-toast');
  if (!t) { t = document.createElement('div'); t.id = 'uau-toast'; document.body.appendChild(t); }
  t.textContent = msg;
  t.classList.add('is-visible');
  clearTimeout(_toastTimer);
  _toastTimer = setTimeout(() => t.classList.remove('is-visible'), 2800);
}

/* Init */
document.addEventListener('DOMContentLoaded', function () {
  /* Cart btn */
  document.querySelectorAll('[data-cart-open]').forEach(el => {
    el.addEventListener('click', uauOpenCart);
  });
  /* Close cart */
  document.querySelectorAll('[data-cart-close]').forEach(el => {
    el.addEventListener('click', uauCloseCart);
  });
  /* Cart backdrop */
  const backdrop = document.querySelector('.cart-drawer-backdrop');
  if (backdrop) backdrop.addEventListener('click', uauCloseCart);

  /* Hamburger */
  document.querySelectorAll('[data-hamburger]').forEach(el => {
    el.addEventListener('click', uauToggleMobileNav);
  });
  document.querySelector('.mobile-nav-overlay')?.addEventListener('click', uauToggleMobileNav);

  /* Product page */
  if (document.querySelector('.product-detail-wrap')) uauInitProductPage();

  /* Quick-add cards */
  document.querySelectorAll('[data-quick-add]').forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();
      const variantId = btn.dataset.variantId;
      if (variantId) uauAddToCart(variantId, 1);
    });
  });

  /* Fetch live cart count on load */
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const count = cart.item_count;
      document.querySelectorAll('.cart-count').forEach(el => {
        el.textContent = count;
        el.style.display = count > 0 ? 'flex' : 'none';
      });
    })
    .catch(() => {});
});
